class SlideshowMain extends HTMLElement {
    constructor() {
        super();
        this.autoplay = true;
        this.currentSlide = null;
    }

    connectedCallback() {
        setTimeout(() => {
            this.initSlideshow();
        }, 10);
    }

    initSlideshow() {
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const autoplaySlideshow = this.dataset.disableAutoplay ? false : !prefersReducedMotion;

        const splideElem = this.querySelector('[id^="Slider-splide-"]');
        this.splide = new Splide(splideElem, {
            type: "loop",
            autoplay: autoplaySlideshow,
            interval: 6000
        });

        this.splide.on("mounted", () => {
            this.initSlides();
        });
        this.splide.mount();

        this.splide.on("active", (slide) => {
            if (slide.isClone) return;
            this.currentSlide = slide.slide;
        });

        this.splide.on("visible", (slide) => {
            // this.currentSlide = slide.slide;
            this.initSlide(slide.slide);
        });

        this.splide.on("hidden", (slide) => {
            const videos = slide.slide.querySelectorAll("video[data-loaded='true']");
            if (videos.length === 0) return;
            videos.forEach(video => {
                video.pause();
            });
        });

        const track = this.splide.Components.Elements.track;
        track.querySelectorAll('button').forEach(button => {
            button.addEventListener('click', (event) => {
                this.splide.Components.Autoplay.pause()
            });
        });

        window.addEventListener('resize', () => {
            this.initSlide(this.currentSlide);
        });
    }

    goToSlide(slideNum) {
        this.splide.go(slideNum);
    }

    initSlides() {
        this.splide.Components.Slides.forEach((slide) => {
            if (slide.index === this.splide.index) this.currentSlide = slide.slide;
            this.initSlide(slide.slide);
        }, true);
    }

    initSlide(slide) {
        const videos = slide.querySelectorAll("video");
        if (videos.length === 0) return;

        videos.forEach(video => {
            if (video.dataset.loaded) {
                video.play();
                return;
            }

            let sourceSet = false;
            for (let source of video.children) {
                // Check if media attribute matches
                const media = source.getAttribute('data-media');
                if (media) {
                    const mq = window.matchMedia(media);
                    if (!mq.matches) continue;
                }
                source.src = source.dataset.src;
                sourceSet = true;
            }

            if (!sourceSet) return;

            video.load();
            video.dataset.loaded = true;
            video.play();
        });
    }
}

customElements.define("slideshow-main", SlideshowMain);
